<div class="landing">
  <landing-header></landing-header>

  <main>
    <router-outlet></router-outlet>
  </main>

  <landing-footer />
</div>
